import { DashboardLayout } from '@repo/ui/components/dashboard-layout';
import { lazy, Suspense } from 'react';

const TravauxManagement = lazy(() =>
  import('@repo/ui/features/travaux/index').then((mod) => ({ default: mod.TravauxManagement })),
);

export default function TravauxPage() {
  return (


    <Suspense fallback={<div className="flex items-center justify-center h-96">Loading ...</div>}>
      <TravauxManagement />
    </Suspense>

  );
}

